"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _useRedirect = _interopRequireDefault(require("@sprinx/react-routes/useRedirect"));

var _styles = require("@material-ui/core/styles");

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _ListItem = _interopRequireDefault(require("@material-ui/core/ListItem"));

var _ListItemIcon = _interopRequireDefault(require("@material-ui/core/ListItemIcon"));

var _usePopulateCatalogueHref = _interopRequireDefault(require("../../app/AppSettingsProvider/usePopulateCatalogueHref"));

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      paddingLeft: theme.spacing(0.5),
      paddingRight: theme.spacing(0.5),
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
      overflow: 'hidden'
    },
    image: {
      width: '100%'
    },
    imageContainer: {
      width: '10%',
      minWidth: 45
    },
    text: (0, _defineProperty2.default)({
      width: '90%',
      fontSize: 16,
      paddingLeft: theme.spacing(1)
    }, theme.breakpoints.down('sm'), {
      fontSize: 14
    })
  };
}, {
  name: 'SxSearchResultSelectorTaxonomy'
});

function SearchResultSelectorTaxonomy(_ref) {
  var pClasses = _ref.classes,
      className = _ref.className,
      item = _ref.item,
      onClose = _ref.onClose,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["classes", "className", "item", "onClose"]);
  var classes = useStyles({
    classes: pClasses
  });
  var setRedirect = (0, _useRedirect.default)();
  var populateCatalogueHref = (0, _usePopulateCatalogueHref.default)();

  var taxonomy = _react.default.useMemo(function () {
    return populateCatalogueHref(item);
  }, [item, populateCatalogueHref]);

  var handleRedirect = function handleRedirect() {
    onClose();
    setRedirect(taxonomy.href);
  };

  return /*#__PURE__*/_react.default.createElement(_ListItem.default, (0, _extends2.default)({}, rest, {
    className: (0, _clsx.default)(classes.root, className),
    component: "div",
    onClick: handleRedirect,
    button: true
  }), /*#__PURE__*/_react.default.createElement(_ListItemIcon.default, {
    className: classes.imageContainer
  }, /*#__PURE__*/_react.default.createElement("img", {
    className: classes.image,
    src: item.image,
    alt: item.title
  })), /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: classes.text
  }, item.title));
}

process.env.NODE_ENV !== "production" ? SearchResultSelectorTaxonomy.propTypes = {
  classes: _propTypes.default.shape({
    image: _propTypes.default.string,
    imageContainer: _propTypes.default.string,
    root: _propTypes.default.string,
    text: _propTypes.default.string
  }),
  className: _propTypes.default.string,
  item: _propTypes.default.shape({
    href: _propTypes.default.string,
    image: _propTypes.default.string,
    title: _propTypes.default.arrayOf(_propTypes.default.shape({}))
  }).isRequired,
  onClose: _propTypes.default.func
} : void 0;
SearchResultSelectorTaxonomy.defaultProps = {
  classes: undefined,
  className: undefined
};
var _default = SearchResultSelectorTaxonomy;
exports.default = _default;